// src/hooks/useDealDisplayInfos.ts
// Phase-4 Runde 2a, Nachtrag (/deals im neuen Design): dieselbe Lade-/Aufloeselogik, die
// bisher nur in AppShell.tsx' MeineDealsSection (Seitenleiste) steckte, jetzt auch von
// Portfolio.tsx fuer die Karten gebraucht -- hierher ausgelagert statt einer 2. Kopie.
// Laedt die Standort-/PLZ-Daten EINMAL fuer die gesamte uebergebene Deal-Liste (nicht pro
// Karte/Deal einen eigenen useStandort()-Aufruf), danach reine Objektzugriffe.
import { useEffect, useState } from "react";
import type { PortfolioObject } from "./usePortfolio";
import { loadData as loadStandortData, loadPlzBundesland } from "./useStandort";
import { resolveDealDisplayInfo, type DealDisplayInfo } from "../lib/dealSidebarDisplay";

export function useDealDisplayInfos(
  deals: Pick<PortfolioObject, "id" | "analyzer_type" | "data" | "plz">[]
): Record<string, DealDisplayInfo | null> {
  const [display, setDisplay] = useState<Record<string, DealDisplayInfo | null>>({});

  useEffect(() => {
    if (deals.length === 0) {
      setDisplay({});
      return;
    }
    let cancelled = false;
    Promise.all([loadStandortData(), loadPlzBundesland()]).then(([standortData, plzBundesland]) => {
      if (cancelled) return;
      const next: Record<string, DealDisplayInfo | null> = {};
      for (const deal of deals) {
        next[deal.id] = resolveDealDisplayInfo(deal, standortData, plzBundesland);
      }
      setDisplay(next);
    });
    return () => {
      cancelled = true;
    };
    // Bugfix 16.10.2026 (Dominiks Live-Test: Seitenleiste zeigte nach dem Speichern weiter
    // den alten Score): die Abhaengigkeit hing bisher NUR an den Deal-IDs, nicht an deren
    // data/plz -- blieb deals.id-Menge gleich (der Normalfall bei "Details ergaenzen"),
    // wurde resolveDealDisplayInfo() nie mit den frischen Werten neu berechnet, selbst wenn
    // usePortfolio() (siehe dort) eine aktualisierte objects-Liste geliefert hat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(deals.map((d) => ({ id: d.id, data: d.data, plz: d.plz })))]);

  return display;
}
